export function parseBETSurfaceAreaPlot(blocks) {
  const betSurfaceAreaPlot = {};
  for (let block of blocks) {
    let submatrix = block['BET Surface Area Plot'];
    if (!submatrix) continue;

    let headers = [];
    for (let row of submatrix) {
      if (row[0] && row[1]) {
        headers = row;
        break;
      }
    }

    betSurfaceAreaPlot.variables = {
      x: {
        data: [],
        label: headers[0].replace(/(.*) \((.*)\)/, '$1'),
        units: headers[0].replace(/(.*) \((.*)\)/, '$2'),
      },
      y: {
        data: [],
        label: headers[1],
        units: '',
      },
    };

    for (let row of submatrix) {
      if (!Number.isNaN(Number(row[0])) && !Number.isNaN(Number(row[1]))) {
        betSurfaceAreaPlot.variables.x.data.push(Number(row[0]));
        betSurfaceAreaPlot.variables.y.data.push(Number(row[1]));
      }
    }
    for (let row of submatrix) {
      if (!Number.isNaN(Number(row[2])) && !Number.isNaN(Number(row[3]))) {
        betSurfaceAreaPlot.variables.x.data.push(Number(row[2]));
        betSurfaceAreaPlot.variables.y.data.push(Number(row[3]));
      }
    }
  }
  return betSurfaceAreaPlot;
}
